export default "__VITE_ASSET__Bk8y9m$a__"